module.exports = __webpack_public_path__ + "static/icons/icon-map--chile-207a902a47c3c5bf94679123dc9d690c.svg";